var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ds-control mobile dsf_teas_student_twobring" },
    [
      _c(
        "div",
        { staticClass: "two_bring-content" },
        _vm._l(_vm.list, function (item, index) {
          return _c(
            "div",
            {
              key: "twobring" + index,
              staticClass: "two_bring-content-item",
              class: index == 0 ? "itemnomargintop" : "",
            },
            [
              _c("div", { staticClass: "question" }, [
                _vm._v(_vm._s(item.title)),
              ]),
              _c("div", { staticClass: "leftlump" }),
              _c("div", { staticClass: "errormessage" }, [
                _vm._v(_vm._s(item.errorMessage)),
              ]),
              _c(
                "div",
                { staticClass: "questiontypes" },
                [
                  _vm._l(item.child, function (childItem, typeindex) {
                    return _c(
                      "div",
                      {
                        key: "type" + typeindex,
                        staticClass: "typeItem",
                        class: typeindex == 0 ? "typeItemno" : "",
                      },
                      [
                        _c("div", { staticClass: "canEdite" }, [
                          _c(
                            "div",
                            { staticClass: "editeLabel" },
                            [
                              _c("div", [
                                _vm._v("我的提问" + _vm._s(typeindex + 1)),
                              ]),
                              _vm.isview == 0
                                ? _c("dsf-icon", {
                                    staticClass: "icon-shanchu",
                                    on: {
                                      click: function ($event) {
                                        return _vm.shanchu(index, typeindex)
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "questioncontent" }, [
                            _c("div", { staticClass: "questiontype" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "defualttitle",
                                  class: _vm.isview == 1 ? "readonlyTitle" : "",
                                },
                                [
                                  _vm.isview == 0
                                    ? _c("span", { staticClass: "xinghao" }, [
                                        _vm._v("*"),
                                      ])
                                    : _vm._e(),
                                  _vm._v("问题类型 "),
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "dropcontent" },
                                [
                                  _c(
                                    "van-dropdown-menu",
                                    { staticClass: "dropdown" },
                                    [
                                      _c("van-dropdown-item", {
                                        attrs: {
                                          options: item.questionType,
                                          disabled: _vm.isview != 0,
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.change(index, typeindex)
                                          },
                                        },
                                        model: {
                                          value: childItem.question_type,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              childItem,
                                              "question_type",
                                              $$v
                                            )
                                          },
                                          expression: "childItem.question_type",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm.isview == 0
                                    ? _c("dsf-icon", {
                                        staticClass: "right",
                                        attrs: { name: "icon_more" },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]),
                            _c("div", { staticClass: "questiondetail" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "defualttitle",
                                  class: _vm.isview == 1 ? "readonlyTitle" : "",
                                },
                                [_vm._v(" 问题描述 ")]
                              ),
                              _c(
                                "div",
                                { staticClass: "filed" },
                                [
                                  _c("van-field", {
                                    attrs: {
                                      rows: "2",
                                      autosize: "",
                                      readonly: _vm.isview != 0,
                                      type: "textarea",
                                      maxlength: "500",
                                      placeholder: "请输入问题描述",
                                      "show-word-limit": _vm.isview == 0,
                                    },
                                    on: {
                                      blur: function ($event) {
                                        return _vm.updatefield(index, typeindex)
                                      },
                                    },
                                    model: {
                                      value: childItem.content,
                                      callback: function ($$v) {
                                        _vm.$set(childItem, "content", $$v)
                                      },
                                      expression: "childItem.content",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                            (childItem.annex && _vm.isview == 1) ||
                            _vm.isview == 0
                              ? _c(
                                  "div",
                                  { staticClass: "files" },
                                  [
                                    _c("DsfMobileUploadFile", {
                                      attrs: {
                                        label: "附件",
                                        uploadFileNum: "1",
                                        inputAlign: "left",
                                        readOnly: _vm.isview == 1,
                                        showDownload: true,
                                      },
                                      on: {
                                        "upload-file": function ($event) {
                                          return _vm.uploadfile(
                                            index,
                                            typeindex
                                          )
                                        },
                                      },
                                      model: {
                                        value: childItem.annex,
                                        callback: function ($$v) {
                                          _vm.$set(childItem, "annex", $$v)
                                        },
                                        expression: "childItem.annex",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]),
                        ]),
                      ]
                    )
                  }),
                  _vm.isview == 0
                    ? _c(
                        "div",
                        { staticClass: "addcontent" },
                        [
                          _c("dsf-icon", {
                            staticClass: "tianjia icon-add",
                            on: {
                              click: function ($event) {
                                return _vm.add(index)
                              },
                            },
                          }),
                          _c(
                            "div",
                            {
                              staticClass: "addtext",
                              on: {
                                click: function ($event) {
                                  return _vm.add(index)
                                },
                              },
                            },
                            [_vm._v("新增提问")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                2
              ),
            ]
          )
        }),
        0
      ),
      _vm.isview == 0
        ? _c("div", { staticClass: "btns" }, [
            _c(
              "div",
              {
                staticClass: "save",
                on: {
                  click: function ($event) {
                    return _vm.submit(0)
                  },
                },
              },
              [_vm._v("暂存")]
            ),
            _c(
              "div",
              {
                staticClass: "submit",
                on: {
                  click: function ($event) {
                    return _vm.submit(1)
                  },
                },
              },
              [_vm._v("提交")]
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }